import * as React from 'react';
import { clsx as cx } from 'clsx';

import { TControlProps } from '../../types';

import * as styles from './styles.css';

export interface IControlInputProps extends TControlProps {
  // NOTE: value может быть number
  value?: string | number;
  type: 'radio' | 'checkbox';
  /** Класс обязателен, чтобы не забыть что этот элемент является корневной нодой для вьюхи */
  className: string;
  /** Перед этими элементами будет нативный инпут, от которого нужно брать стили для активного состояния(:checked) */
  children: React.ReactNode;
}

/** Дублирует компонент ControlInputContainer в ui-kit. Отличие в прямой отрисовке input  **/

export const ControlInput = React.forwardRef(function ControlInputContainer(
  props: IControlInputProps,
  ref: React.Ref<HTMLLabelElement>,
) {
  const {
    type,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    label,
    checked,
    defaultChecked,
    disabled,
    onChange,
    inputRef,
    tabIndex,
    name,
    id,
    autoFocus,
    children,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    invalid,
    value,
    role,
    ...rest
  } = props;
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (onChange) {
      onChange(e, e.currentTarget.checked);
    }
  };

  return (
    <label {...rest} className={cx(rest.className, styles['container'])} ref={ref}>
      <input
        {...(value && { value })}
        type={type}
        ref={inputRef}
        checked={checked}
        defaultChecked={defaultChecked}
        disabled={disabled}
        onChange={handleChange}
        tabIndex={tabIndex}
        name={name}
        id={id}
        autoFocus={autoFocus}
        role={role}
        className={cx(styles['input'], props.className)}
        aria-hidden
      />
      {children}
    </label>
  );
});
